/* Patron dimensions */
export const PATRON_INPUT_HEIGHT = 50;

/* Patron colours */
export const PATRON_INPUT_BACKGROUND_COLOUR = "#F5F5F5";
export const PATRON_INPUT_PLACEHOLDER_COLOUR = "#5D5F70";
